<template>
  <div class="page" id="credits-buy">
    <div class="card">
      <div class="header">
        <div class="description">
          <h2 class="title">ADICIONAR CARTÃO DE CRÉDITO</h2>
          <p class="subtitle">Preencha os dados do seu cartão de crédito.</p>
        </div>
      </div>

      <div class="body -not-finished" v-if="!finished">
        <div class="bg-blue-100 border border-blue-400 text-blue-700 px-4 py-3 rounded relative mb-5 bg-opacity-25" role="alert">
          <span class="block sm:inline">Será feita uma cobrança de R$ 1,00 para validar seu cartão. Esse valor será estornado automaticamente.</span>
          <span class="absolute top-0 bottom-0 right-0 px-4 py-3"></span>
        </div>

        <form id="payment-form" @submit.prevent="">
          <div>
            <div class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-3" role="alert"  v-show="paymentErrorMessage">
              <span class="block sm:inline">{{ paymentErrorMessage }}</span>
              <span class="absolute top-0 bottom-0 right-0 px-4 py-3"></span>
            </div>

            <div id="payment-element"></div>
          </div>

          <button class="btn btn-primary -full-width mt-5" @click="addPaymentMethod">
            <div class="spinner hidden" id="spinner"></div>
            <span id="button-text">Adicionar</span>
          </button>
        </form>
      </div>

      <div class="body -finished" v-if="finished">
        <success-checkmark/>

        <h2 class="title">Cartão adicionado com sucesso.</h2>
        <div class="actions">
          <router-link
            :to="{name: 'PlanDetail'}"
            class="btn btn-primary"
          >Visualizar os detalhes da sua assinatura
          </router-link>
        </div>
      </div>

      <loader v-if="loading"/>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Loader from '@/support/components/Loader.vue';
import SuccessCheckmark from '@/support/components/SuccessCheckmark.vue';
import currency from '@/support/filters/currency';

export default {
  name: 'AddPaymentMethod',

  data() {
    return {
      loading: false,
      finished: false,
      payment: null,
      elements: null,
      paymentErrorMessage: '',
    };
  },

  methods: {
    async addPaymentMethod() {
      this.loading = true;
      this.paymentErrorMessage = '';

      const stripeResponse = await this.$stripe.confirmPayment({
        elements: this.elements,
        redirect: 'if_required',
      });

      if (stripeResponse.error) {
        this.paymentErrorMessage = stripeResponse.error.message;
        this.loading = false;
        return;
      }

      this.loading = false;
      this.finished = true;
    },
  },

  watch: {
  },

  computed: {
    ...mapState('credits', {
      intent: 'intent',
    }),
  },

  async mounted() {
    this.loading = true;

    await this.$store.dispatch('credits/paymentMethodIntentCreate', this.$route.params.id);

    this.elements = this.$stripe.elements({ clientSecret: this.intent.clientSecret });
    this.payment = this.elements.create('payment');
    this.payment.mount('#payment-element');
    this.payment.on('ready', () => {
      this.loading = false;
    });
  },

  filters: {
    currency,
  },

  directives: {
  },

  beforeDestroy() {
    if (this.payment) {
      this.payment.destroy();
    }
  },

  components: {
    Loader,
    SuccessCheckmark,
  },
};
</script>

<style lang="scss" scoped>
  #credits-buy {
    > .card {
      > .body, .body form {
        > .alert {
          @apply mb-4;
        }

        > .choose-payment-method {
          > .paymentOptions {
            @apply flex;
            @apply flex-wrap;
            @apply gap-4;

            @screen md {
              @apply flex-no-wrap;
            }

            > .option {
              @apply w-full;
              @apply p-4;
              @apply border;
              @apply border-solid;
              @apply border-gray-400;
              @apply rounded;
              @apply text-grey-800;
              @apply font-bold;
              @apply cursor-pointer;

              @screen md {
                @apply w-auto;
                min-width: auto;
              }

              > .form-check-input {
                @apply relative;
                top: 1px;
              }

              > .icon {
                @apply ml-2;
                @apply relative;
                top: 2px;
              }
            }
          }

          &.-has-error {
            > .paymentOptions {
              > .option {
                @apply border-red-500;
              }
            }
          }
        }

        &.-finished {
          > .title {
            @apply text-2xl;
            @apply text-center;
            font-weight: bold;
            font-family: 'Roboto Slab', serif;
          }

          > .description {
            @apply pb-4 px-4;
            @apply text-sm;
            @apply text-center;
          }

          > .actions {
            @apply text-center;
            @apply mt-4;
            > .btn {
              @apply mx-1;
            }
          }
        }
      }
    }
  }
</style>
